import { useReducer, useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation, } from 'react-router-dom'
import { useMediaQuery } from '@material-ui/core' // Srini 07-01-25


import Header from './Components/MainUiPages/Header/Header'
import LoginPage from './Components/LoginPage/LoginPage'
import NavigateTabs from './Components/MainUiPages/LeftHand/NavigateTabs/NavigateTabs'
import SnackbarAlert from './Components/Snackbar/Snackbar'
import PrivateRouter from './helpers/PrivateRouter'
import CallImage from './Components/MainUiPages/RightHand/DashboardPage/CallModal/CallIcon'
import CallerModal from './Components/MainUiPages/RightHand/DashboardPage/CallModal/CallerModal'

import reducer from './useReducers/useReducers'
import { reducerContext } from "./contextApi's/contextApi's"
import snackError from './helpers/snackError'
import {jwtDecode} from "jwt-decode"
// Initial state constant 
const initialState = {
  additionalRoles: 0,
  agentNo: '',
  agentHangUp: false,
  answerBtn: false,
  agentPublishStatus: 'open', // new state - 19/09/24 - dev srini
  breakModal: false,
  buttonType: '',
  callAccept: false,
  callDomain: '',
  callDuration: 0,
  callHistory: [],
  callHistoryChat: [],
  callLabel: '',
  callLogs: [],
  callNumber: '',
  callUuid: '',
  callerInfoModal: false,
  callIconToggle: false,
  clientId: '', // srini - 28/11/24
  clientRefCode: '', // srini - 28/11/24
  customerName: '',
  customerEmail: '',
  customerLocation: '',
  customerState: '',
  customerPortfolios: [],
  customerPhoneNumber: '',
  customerPendingTasks: [],
  displayPhoneNumber: '',
  editUser: false,
  errorMsg: '',
  faqCategories: [], // srini - 06-05-25
  faqSubCategories: [], // srini - 06-05-25
  faqs:[], // srini - 06-05-25
  faqTags: [], // srini - 06-05-25
  isLoggedIn: false,
  isCallHangUp: true,
  isCallActive: false,
  inBound: '',
  mySnack: snackError.mySucc,
  outBoundCalling: false,
  playBackAudio: new window.Audio(),
  refreshToken: false,
  showButton: false,
  showDomain: false,
  showErr: false,
  showTransfer: false,
  sipStatus: false,
  sipRegStsMsg: '',
  socStsMsg: '',
  startCall: false,
  tokenValid: '',
  tagPreviousIssue: '',
  timer: 0,
  uId: 0,
  userId: 0,
  userData: [],
}


const App = () => {

  const navigate = useNavigate()
  const location = useLocation()

  const [state, dispatch] = useReducer(reducer, initialState)
  const departmentName = localStorage.getItem('departmentName') // Srini 07-01-25
  const isSmallScreen = useMediaQuery('(max-width: 600px)') // Srini 07-01-25

  // Dev Srini 25/10/24
    // useEffect(() => {
    //   const token = localStorage.getItem('token')
    //   let isValid = false

    //   console.log("helloo", token, state.tokenValid, state.tokenValid?.length,isValid)

      
    //     // navigate('/incomplete-kyc')
       

    //   // if (token) {
    //   //   console.log("token")
    //   //   navigate('/incomplete-kyc')
    //   //   dispatch({
    //   //     type: 'USER_SIGN_IN',
    //   //     payload: true
    //   //   })
    //   //   dispatch({ type: 'SET_TOKEN_VAL', payload: 'Valid' })
    //   // }
    //   if (token) {
    //     try {
    //       const decoded = jwtDecode(token)
    //       const now = Date.now() / 1000 // current time in seconds
    //       if (decoded.exp && decoded.exp > now) {
    //         isValid = true
    //         console.log("Token is valid, expires at:", new Date(decoded.exp * 1000).toISOString())
    //       } else {
    //         console.warn("Token expired at:", new Date(decoded.exp * 1000).toISOString())
    //         localStorage.removeItem('token')
    //       }
    //     } catch (err) {
    //       console.error("Invalid token:", err)
    //       localStorage.removeItem('token')
    //     }
    //   }

    //   if (isValid) {
    //     navigate('/incomplete-kyc')
    //     dispatch({ type: 'USER_SIGN_IN', payload: true })
    //     dispatch({ type: 'SET_TOKEN_VAL', payload: 'Valid' })
    //   } else {
    //     if (location.pathname !== '/') {
    //       navigate('/')
    //     }
    //   }



    //   // if (!token) {
    //   //   console.log("con")
    //   //   if (location.pathname !== '/') {
    //   //     console.log("con1")
    //   //     navigate('/')
    //   //   }
    //   // }
    //   // else {
    //   //   console.log("else")
    //   //   if (location.pathname === '/') {
    //   //     console.log("else1")
    //   //     // Srini 07-01-25
    //   //     // if (isSmallScreen && departmentName === 'Franchisee') {
    //   //     //   navigate('/franchiseDashboard')
    //   //     // } else {
    //   //     //   navigate('/incomplete-kyc')
    //   //     // }
    //   //     navigate('/incomplete-kyc')
    //   //   }
    //   // }

    // }, [])



  useEffect(() => {
    const token = localStorage.getItem('token');
    let logoutTimer;

    if (!token) {
      if (location.pathname !== '/') {
        navigate('/');
      }
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000;

      // Token expired
      if (!decoded.exp || decoded.exp <= now) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('kyc_redirected');
        sessionStorage.removeItem('last_route');
        if (location.pathname !== '/') {
          navigate('/');
        }
        return;
      }

      // Auto logout timer
      const timeUntilExpiry = (decoded.exp - now) * 1000;
      logoutTimer = setTimeout(() => {
        localStorage.removeItem('token');
        sessionStorage.removeItem('kyc_redirected');
        sessionStorage.removeItem('last_route');
        dispatch({ type: 'USER_SIGN_IN', payload: false });
        dispatch({ type: 'SET_TOKEN_VAL', payload: '' });
        navigate('/');
        dispatch({ type: 'SET_SHOW_ERROR', payload: true });
        dispatch({ type: 'SET_ERROR', payload: 'Session Expired please login' });
        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
      }, timeUntilExpiry);

      // Save last route on every navigation
      sessionStorage.setItem('last_route', location.pathname);

      const lastRoute = sessionStorage.getItem('last_route');
      const hasKycRedirected = sessionStorage.getItem('kyc_redirected');

      // Redirect to incomplete-kyc if first login or reload before KYC done
      if (!hasKycRedirected) {
        if (!lastRoute || lastRoute === '/' || lastRoute === '/login') {
          navigate('/incomplete-kyc');
          sessionStorage.setItem('kyc_redirected', 'true');
        }
      }

      dispatch({ type: 'USER_SIGN_IN', payload: true });
      dispatch({ type: 'SET_TOKEN_VAL', payload: 'Valid' });

    } catch (err) {
      localStorage.removeItem('token');
      sessionStorage.removeItem('kyc_redirected');
      sessionStorage.removeItem('last_route');
      if (location.pathname !== '/') {
        navigate('/');
      }
    }

    return () => {
      if (logoutTimer) clearTimeout(logoutTimer);
    };
  }, [dispatch, navigate, location.pathname]);


    

  return (
    <div>
      <reducerContext.Provider value={{ state, dispatch }}>
        <Header />
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/:activePage"
            element={
              <PrivateRouter>
                <NavigateTabs
                  location={location}
                />
                {/* Srini 07-01-25 */}
                {/* {(!isSmallScreen) && <CallImage />} 
                {(!isSmallScreen) && <CallerModal />} */}
              </PrivateRouter>
            }
          />
        </Routes>
        <SnackbarAlert />
      </reducerContext.Provider>
    </div>
  )
}

export default App
